import { createContext, Dispatch, FormEvent, SetStateAction, useContext } from 'react';
import { Guide, GuideSummary } from 'types/guide';
import { ReportGuideQueryParams } from './useFetchReportGuides';

export interface ReportGuideContextValue {
  anchorEl: HTMLButtonElement | null;
  setAnchorEl: Dispatch<SetStateAction<HTMLButtonElement | null>>;
  filter: ReportGuideQueryParams;
  handleChange(index: keyof ReportGuideQueryParams, value: any): void;
  handleSearch(e?: FormEvent<HTMLFormElement>): void;
  loading: boolean;
  setSelectedGuide: Dispatch<SetStateAction<Guide | null>>;
  selectedGuide: Guide | null;
  guides: Guide[];
  summary: GuideSummary | null;
}

const ReportGuideContext = createContext<ReportGuideContextValue>({} as ReportGuideContextValue);
export const ReportGuideProvider = ReportGuideContext.Provider;
export const ReportGuideConsumer = ReportGuideContext.Consumer;

export function useReportGuide(): ReportGuideContextValue {
  const context = useContext(ReportGuideContext);
  return context;
}
